import Axios from "axios";
import React, { useEffect, useState } from "react";
import { CircularProgress, Typography } from "@mui/material";
import Moment from "moment";
import { Form, Formik } from "formik";
import Swal from "sweetalert2";
import automaticValidationSchema from "../../../Utilities/ValidationSchemaSetup/automaticValidationSchema";
import * as Yup from "yup";
import FormikControl from "../../../Components/HealthInsFormikComponent/FormikControl";
import DocUploadGenRef from "./DocUploadGenRef";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";

const FormSecondaryGenRef = (props) => {
  const { decryptedResponseId, decryptedProductRef, setParentNext,kyc_configId,a_id } = props;
  const [starGenRefDetails, setStarGenRefDetails] = useState({});
  const [quickQuoteDetails, setQuickQuoteDetails] = useState({});

  var initialValues;
  if (Object.keys(starGenRefDetails).length > 0) {
    
    initialValues = { ...starGenRefDetails.initialValues };
    initialValues = {
      ...initialValues,
      idorAddressProofSelect: "",
      idOrAddressProofDocumentFrontSide: "",
      idOrAddressProofDocumentBackSide: "",
      photographDoc: "",
      form60Document: "",
      isForm60required: "",
    };
  }
  console.log("initialValues: ", initialValues);

  // console.log('sss', Fields[0])
  // const { values, setFieldValue } = useFormikContext()
  const [activeStep, setActiveStep] = React.useState(0);
  // const [isForm60required, setForm60required] = React.useState(false);
  const productName = "Star Secondary Gen Ref Form";
  const steps = ["PROPOSER DETAILS", "DOCUMENT UPLOADS"];

  var Fields = [];
  var validationSchema = Yup.object().shape({});

  if (Object.keys(starGenRefDetails).length > 0 && !activeStep) {
    Fields.push(starGenRefDetails.requestBody.formFields.fields);
    console.log("Fields : ", Fields);
    validationSchema = automaticValidationSchema(Fields[0]);
  } else if (Object.keys(starGenRefDetails).length > 0) {
    validationSchema = Yup.object().shape({
      idorAddressProofSelect: Yup.string().required(
        "Document type must be Selected"
      ),
      idOrAddressProofDocument: Yup.mixed().when("idorAddressProofSelect", {
        is: "a",
        then: Yup.string().required("Document must be provided"),
      }),
      idOrAddressProofDocumentFrontSide: Yup.mixed().when(
        "idorAddressProofSelect",
        {
          is: "b",
          then: Yup.string().required("Document FrontSide must be provided"),
        }
      ),
      idOrAddressProofDocumentBackSide: Yup.mixed().when(
        "idorAddressProofSelect",
        {
          is: "b",
          then: Yup.string().required("Document BackSide must be provided"),
        }
      ),
      photographDoc: Yup.string().required("Photograph Document is Required"),
      form60Document: Yup.mixed().when("isForm60required", {
        is: true,
        then: Yup.string().required("Form60 Document is Required"),
      }),
    });
  }

  useEffect(() => {
    let productDetailsArray = [];
    let domain = "";
     

    axiosInstance.get(`getKYC_config/${kyc_configId}`)
      .then((response) => {
        if (response.status === 200) {
          console.log("Response From ExpressMongoTest: ", response.data);

          setStarGenRefDetails(response.data);
        }
      })
      .catch((e) => {
        alert(e);
      });

     

    axiosInstance.get(`api/health/transfer-data/${decryptedResponseId}`)
      .then((response) => {
        if (response.status === 200) {
          console.log("response from djamgoo ", response);
          response.data.insureds.map((insure, insureIndex) => {
            localStorage.setItem(`date[${insureIndex}]`, `${insure.dob}`);
          });
          setQuickQuoteDetails(response.data);
          // setdepInd(response.data.number_of_insured)
          // productDetailsArray.push(response.data)
          //setProductDetails(productDetailsArray);
          // setProductDetails(response.data);
        }
      })
      .catch((e) => {
        alert(e);
      });

    /* let utilityScript = document.createElement("script");
        utilityScript.src = utility;
        document.body.appendChild(utilityScript); */
    return () => {
      localStorage.clear();
    };
  }, []);

  const starBodyJson = {
    idOrAddressProofDocumentId: 1,
    idOrAddressProofDocumentNumber: "AAAAA0000A",
    titleId: 1,
    firstName: "Swadhin",
    middleName: "",
    lastName: "Dhal",
    genderId: 1,
    birthdate: "September 23, 1988",
    occupationId: 1,
    residentialStatusId: 1,
    pan: "AAAAA0000A",
    familyRelationshipId: 3,
    familyMemberTitleId: 2,
    familyMemberFirstName: "Rachita",
    familyMemberLastName: "Dhal",
    addressLineOne: "No. 20",
    addressLineTwo: "Nehru Street",
    cityName: "Triplicane",
    districtName: "Chennai",
    stateCode: "TN",
    countryCode: "IN",
    postalCode: "600005",
    incomeSourceId: 1,
    isAnyonePEP: 0,
  };

  const onSubmit = (data, actions) => {
    // Do something with the next handler
    if (activeStep === 0) {
      window.scrollTo(0, 0);
      setActiveStep(1);
      actions.setTouched({});
      actions.setSubmitting(false);
    } else {
      let domain = "";
      if (window.location.hostname === "localhost") {
        domain = process.env.REACT_APP_LOCAL_DJANGO;
      } else if (window.location.hostname.trim() === "it.acuvisor.com") {
        domain = process.env.REACT_APP_PRODUCTION_DJANGO;
      } else {
        domain = process.env.REACT_APP_UAT_DJANGO;
      }

      var formData = new FormData();

      /* Appending the formData object with the file(s) that the user has selected. */
      formData.append("photographDocument", data.photographDoc);
      const prfSlct = data.idorAddressProofSelect
      if (prfSlct === 'a') {
        formData.append(
          "idOrAddressProofDocument",
          data.idOrAddressProofDocument
        );
        console.log("FrontsideAndBackside appended Solely")
      } else if (prfSlct === 'b') {
        formData.append(
          "idOrAddressProofDocumentFrontSide",
          data.idOrAddressProofDocumentFrontSide
        );
        formData.append(
          "idOrAddressProofDocumentBackSide",
          data.idOrAddressProofDocumentBackSide
        );
        console.log("FrontsideAndBackside appended Separately")
      }

      /* Appending the form60Document to the formData. */
      if (data.isForm60required) {
        formData.append("form60Document", data.form60Document);
        console.log("form60Document appended ")
      }
      let dob =
        data.birthdate === ""
          ? ""
          : Moment(data.birthdate).format("MMMM DD, yyyy");
      console.log("newDate", dob);

      let newReqbody = {
        ...starBodyJson,
        idOrAddressProofDocumentId: data.idOrAddressProofDocumentId,
        idOrAddressProofDocumentNumber: data.idOrAddressProofDocumentNumber,
        titleId: data.titleId,
        firstName: data.firstName,
        middleName: data.middleName,
        lastName: data.lastName,
        genderId: data.genderId,
        birthdate: dob,
        occupationId: data.occupationId,
        residentialStatusId: data.residentialStatusId,
        pan: data.pan,
        familyRelationshipId: data.familyRelationshipId,
        familyMemberTitleId: data.familyMemberTitleId,
        familyMemberFirstName: data.familyMemberFirstName,
        familyMemberLastName: data.familyMemberLastName,
        addressLineOne: data.addressLineOne,
        addressLineTwo: data.addressLineTwo,
        cityName: data.cityName,
        districtName: data.districtName,
        stateCode: data.stateCode,
        countryCode: "IN",
        postalCode: data.postalCode,
        incomeSourceId: data.incomeSourceId,
        isAnyonePEP: data.isAnyonePEP,
      };
      if(data.isAnyonePEP === "1" && data?.pepRemarks !== undefined){
        newReqbody = {...newReqbody,pepRemarks : data.pepRemarks}
      }

      console.log("StarBodyJson: ", newReqbody);
      formData.append("bodyJson", JSON.stringify(newReqbody));

   
      axiosInstance.post(
        `api/health-insurance/starhealth/generate-ckyc-referenceid/${decryptedResponseId}/${a_id}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
      )
        .then((response) => {
          console.log("Response from server: ", response);
          if (response.status === 200) {
            console.log("Success");
            Swal.fire({
              icon: "success",
              title: `Your Reference Id is generated\n REF-ID: ${response.data.ckycReferenceId}`,
              text: "Click on OK button to proceed",
              position: "center",
  
              showClass: {
                popup: "animate__animated animate__fadeInDown",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            }).then((result) => {
              if (result.isConfirmed) {
                setParentNext(false);
                actions.setSubmitting(false);
              }
            });
          }
        })
        .catch((error) => {
          if (error.response.status !== 200) {
            let errMSG = "";
            if (Array.isArray(error.response.data.message)) {
              errMSG = error.response.data.message[0].errDescription;
            } else {
              errMSG = error.response.data.message;
            }
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `${errMSG}`,
              position: "center",
              // showConfirmButton: true,
              // confirmButtonText: "Continue",
              showCancelButton: true,
              cancelButtonText: "Re-Enter Document Details",
              showClass: {
                popup: "animate__animated animate__fadeInDown",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            }).then((result) => {
              // if (result.isConfirmed) {
              //   setSubmitForm(false);
              // } else 
              if (result.dismiss === "cancel") {
                actions.setSubmitting(false);
                setParentNext(true);
              }
              console.log(result, "ff");
            });
            setParentNext(true);
            actions.setSubmitting(false);
          }
          console.log(error);
        });
    }

    console.log("Submit Data", data);
  };

  return (
    <>
      <h3 className="fw-700 text-center my-4 heading-text text-capitalize">
        Generate KYC REF ID
      </h3>
      <div className="mx-auto stepper-container text-wraper">
        <div className="mx-auto stepper-container">
          <div className="Stepper_container">
            <div className="steppers">
              {steps.map((field, index) => {
                return (
                  <div
                    className={activeStep === index ? "active" : `step${index}`}
                    onClick={() => {
                      if (index < activeStep) setActiveStep(index);
                    }}
                    key={index}
                  >
                    <p
                      className={activeStep === index ? "active_text" : "text"}
                    >
                      {field}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          <p className="stepper"></p>
        </div>
      </div>
      {initialValues ? (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={false}
          onSubmit={onSubmit}
        >
          {(formik) => {
            console.log("formik val", formik);
            return (
              <Form>
                <div
                  className="form-container"
                  style={{ marginBottom: "48px" }}
                >
                  {activeStep ? (
                    <DocUploadGenRef
                      formik={formik}
                      // isForm60required={isForm60required}
                    />
                  ) : (
                    <div>
                      {Fields[0].map((field, index) => {
                        return field.htmlElement === "TextField" ? (
                          <div
                            className="mb-3"
                            key={index}
                            hidden={field.hidden}
                          >
                            <FormikControl
                              control="input"
                              name={`${field.name}`}
                              /*  manualValidation={
                                   field.manualValidation
                                 } */
                              //errors={formik.errors}
                              readOnly={field.readOnly}
                              /*  transperData={
                                   productDetails.transperData
                                 }*/
                              url={field.url}
                              label={field.label}
                              type={field.dataType}
                              // touched={formik.touched}
                            />
                          </div>
                        ) : field.htmlElement === "Select" ? (
                          <div
                            className="mb-3"
                            key={index}
                            hidden={field.hidden}
                          >
                            <FormikControl
                              control="select"
                              readOnly={field.readOnly}
                              name={`${field.name}`}
                              quickQuoteDetails={0}
                              //errors={formik.errors}
                              label={field.label}
                              type={field.dataType}
                              //touched={formik.touched}
                              options={field.options}
                            />
                          </div>
                        ) : field.htmlElement === "TextArea" ? (
                          <div
                            className="mb-3"
                            key={index}
                            hidden={field.hidden}
                          >
                            <FormikControl
                              control="textarea"
                              name={`${field.name}`}
                              //errors={formik.errors}
                              label={field.label}
                              type={field.dataType}
                              // touched={formik.touched}
                            />
                          </div>
                        ) : field.htmlElement === "Radio" ? (
                          <div
                            className="mb-3"
                            key={index}
                            hidden={field.hidden}
                          >
                            <FormikControl
                              control="radio"
                              name={`${field.name}`}
                              //errors={formik.errors}
                              dependent={field.dependent}
                              options={field.options}
                              manualValidation={field.manualValidation}
                              //arrayindex={i}
                              label={field.label}
                              type={field.dataType}
                              //touched={formik.touched}
                            />
                          </div>
                        ) : field.htmlElement === "DatePicker" ? (
                          <div
                            className="mb-3"
                            key={index}
                            hidden={field.hidden}
                          >
                            <FormikControl
                              control="date"
                              name={`${field.name}`}
                              //errors={field.errors}
                              readOnly={field.readOnly}
                              label={field.label}
                              type={field.dataType}
                            />
                          </div>
                        ) : field.htmlElement === "checkbox" ? (
                          <div
                            className="mb-3"
                            key={index}
                            hidden={field.hidden}
                          >
                            <FormikControl
                              control="checkBox"
                              name={`${field.name}`}
                              //errors={field.errors}
                              label={field.label}
                              type={field.dataType}
                              options={field.options}
                            />
                          </div>
                        ) : field.htmlElement === "MultiSelect" ? (
                          <div
                            className="mb-3"
                            key={index}
                            hidden={field.hidden}
                          >
                            <FormikControl
                              control="MultiSelect"
                              readOnly={field.readOnly}
                              name={`${field.name}`}
                              productName={productName}
                              //errors={formik.errors}
                              label={field.label}
                              type={field.dataType}
                              // touched={formik.touched}
                              options={field.options}
                              //onChange={(e)=>onChange(e,field.name)}
                              //onChange={(e) => formik.handleChange(e)}
                            />
                          </div>
                        ) : field.htmlElement === "Array" ? (
                          <div
                            className="mb-3"
                            key={index}
                            style={{
                              marginTop: "24px",
                            }}
                          >
                            <h3 className="py-3 second-heading-text">
                              {field.label}
                            </h3>
                            <div className="mb-3">
                              {
                                /* <CreateQuoteDependent
                field={field}
                name={`${Fields[activeStep].name}`}
                quickQuoteDetails={quickQuoteDetails}
                dependentIndex={1}
                /*  transperData={
                                           productDetails.transperData
                                         } */
                                /> */
                              }
                            </div>
                          </div>
                        ) : field.htmlElement === "Object" ? (
                          <div
                            className="mb-3"
                            key={index}
                            style={{
                              marginTop: "24px",
                            }}
                          >
                            {/* <CreateQuoteObjectView
              previousObjectName={`${Fields[activeStep].name}`}
              quickQuoteDetails={quickQuoteDetails}
              data={field}
            /> */}
                          </div>
                        ) : null;
                      })}
                    </div>
                  )}
                  <div className="mt-3">
                  {!formik.isSubmitting ? (
                    <button
                    className="submitBtn "
                    // disabled={formik.isSubmitting}
                    type="submit"
                    // style={{marginBottom:'48px'}}
                  >
                    {activeStep ? "Submit" : "Continue"}
                  </button>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <CircularProgress
                        size={48}
                        sx={{
                          color: "red",
                        }}
                      />
                    </div>
                  )}
                </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      ) : (
        <Typography>Loading....</Typography>
      )}
    </>
  );
};

export default FormSecondaryGenRef;
